const TOKEN_KEY = 'pbl_oc_assistance_session_token';
const SESSION_ID_KEY = 'pbl_oc_assistance_session_id';
const PROFILE_ID_KEY = 'pbl_oc_assistance_profile_id';
const SUBMITTED_CASE_ID_KEY = 'pbl_oc_assistance_submitted_case_id';

const storage = () => (typeof window === 'undefined' ? null : window.sessionStorage);

export const getPblAssistanceToken = () => storage()?.getItem(TOKEN_KEY) || '';
export const getPblAssistanceSessionId = () => Number(storage()?.getItem(SESSION_ID_KEY) || 0) || null;
export const getPblAssistanceProfileId = () => Number(storage()?.getItem(PROFILE_ID_KEY) || 0) || null;
export const isPblAssistanceActive = () => Boolean(getPblAssistanceToken() && getPblAssistanceSessionId());
export const getPblSubmittedAssistedCaseId = () =>
  isPblAssistanceActive() ? Number(storage()?.getItem(SUBMITTED_CASE_ID_KEY) || 0) || null : null;

export const rememberPblSubmittedAssistedCase = (caseId: number) => {
  if (isPblAssistanceActive() && Number.isSafeInteger(caseId) && caseId > 0) {
    storage()?.setItem(SUBMITTED_CASE_ID_KEY, String(caseId));
  }
};

export const startPblAssistance = (sessionId: number, profileId: number, token: string) => {
  storage()?.removeItem(SUBMITTED_CASE_ID_KEY);
  storage()?.setItem(TOKEN_KEY, token);
  storage()?.setItem(SESSION_ID_KEY, String(sessionId));
  storage()?.setItem(PROFILE_ID_KEY, String(profileId));
};

export const clearPblAssistance = () => {
  storage()?.removeItem(TOKEN_KEY);
  storage()?.removeItem(SESSION_ID_KEY);
  storage()?.removeItem(PROFILE_ID_KEY);
  storage()?.removeItem(SUBMITTED_CASE_ID_KEY);
};
